import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import 'i18n/config';
import { useTranslation, Trans } from 'react-i18next';

import theme from '../theme';
import LumaLogo from '../assets/luma-logo-white.png';
import { useNavigate } from 'react-router-dom';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

const SplashScreen: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    React.useEffect(() => {
        if (isMobile) {
            const timer = setTimeout(() => {
                navigate('/home');
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [navigate]);

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    bgcolor: 'background.dark',
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    component="img"
                    src={LumaLogo}
                    alt="Luma Logo"
                    sx={{
                        fontFamily: 'Open Sans',
                        width: '128px',
                        height: '128px',
                        marginBottom: '20px'
                    }}
                />

                <Typography variant="h1" sx={{ mt: 0, fontSize: '2rem', fontWeight: 600, color: 'background.default', }}>
                    Luma Tarot
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        mt: 0,
                        textAlign: 'center',
                        color: 'background.default',
                        px: 4,
                        fontSize: '12pt',
                    }}
                >
                    <p>{t('splashScreen.title')}</p>
                </Typography>

                {!isMobile && (
                    <Box sx={{
                        mt: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        color: 'white'
                    }}>
                        <PhoneIphoneIcon sx={{ fontSize: 60, mb: 2, color: 'white' }} />
                        <Typography variant="body1" sx={{ textAlign: 'center', color: 'white' }}>
                            {t('splashScreen.mobileAccess')}
                        </Typography>
                    </Box>
                )}
            </Box>
        </ThemeProvider>
    );
};

export default SplashScreen;
